import { SplitPageContent } from "@/components/ui/PageWrapper";
import { Flex, Text } from "@givenwell/components";
import { ChatBubbleTextSquareIcon } from "@givenwell/core-solid-icons";
import { colors } from "@givenwell/theme";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/supplier/$supplierId/messages/")({
  component: Messages,
});

function Messages() {
  return (
    <SplitPageContent>
      <Flex
        css={{
          flexDirection: "column",
          flex: "1 0 0px",
          alignItems: "center",
          justifyContent: "center",
          gap: 8,
        }}
      >
        <ChatBubbleTextSquareIcon width="56" height="56" color={colors.text3} />
        <Text css={{ fontScale: "sm", color: colors.text2 }}>Select a message to read</Text>
      </Flex>
    </SplitPageContent>
  );
}
